<template>
    <div class="flex-1 flex flex-col">
        <article>
            <router-view
                v-slot="{ Component }"
                name="modal"
                :key="$route.params.time"
            >
                <component :is="Component"></component>
            </router-view>

            <main class="flex-1 overflow-y-auto focus:outline-none">
                <div class="relative max-w-4xl mx-auto md:px-8 xl:px-0">
                    <div class="pt-10 pb-16">
                        <div class="rounded-lg bg-white overflow-hidden shadow">
                            <h2 class="sr-only" id="profile-overview-title">
                                {{ t("profile.title", "Uw organisatie") }}
                            </h2>

                            <div class="bg-white p-6">
                                <div
                                    class="
                                        sm:flex
                                        sm:items-center
                                        sm:justify-between
                                    "
                                >
                                    <div class="sm:flex sm:space-x-5">
                                        <div
                                            class="flex-shrink-0"
                                            v-if="user.imageUrl"
                                        >
                                            <img
                                                class="
                                                    mx-auto
                                                    h-20
                                                    w-auto
                                                    not-rounded-full
                                                "
                                                :src="user.imageUrl"
                                                alt=""
                                            />
                                        </div>
                                        <div
                                            class="
                                                mt-4
                                                text-center
                                                sm:mt-0 sm:pt-1 sm:text-left
                                            "
                                        >
                                            <p
                                                class="
                                                    text-sm
                                                    font-medium
                                                    text-blue-600
                                                "
                                            >
                                                {{
                                                    t(
                                                        "profile.settings",
                                                        "Instellingen"
                                                    )
                                                }}
                                            </p>
                                            <p
                                                class="
                                                    text-xl
                                                    font-bold
                                                    text-blue-900
                                                    sm:text-2xl
                                                "
                                            >
                                                {{ user.name }}
                                            </p>
                                            <p
                                                class="
                                                    text-sm
                                                    font-medium
                                                    text-blue-800
                                                "
                                            >
                                                {{ user.role }}
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        class="mt-5 flex justify-center sm:mt-0"
                                    >
                                        <a
                                            v-if="isLoading"
                                            class="
                                                flex
                                                justify-center
                                                items-center
                                                px-4
                                                py-2
                                                border border-gray-300
                                                shadow-sm
                                                text-sm
                                                font-medium
                                                rounded-md
                                                text-gray-700
                                                bg-white
                                                hover:bg-gray-50
                                                disabled
                                            "
                                            :class="{
                                                'bg-red-500 text-white':
                                                    isLoading == 'error',
                                            }"
                                        >
                                            <svg
                                                class="animate-spin h-5 w-5"
                                                :class="{
                                                    'text-white':
                                                        isLoading == 'error',
                                                }"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    class="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    stroke-width="4"
                                                ></circle>
                                                <path
                                                    class="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                ></path>
                                            </svg>
                                        </a>

                                        <router-link
                                            v-if="!isLoading"
                                            :to="{
                                                name: 'profile-edit',
                                                params: {
                                                    time: new Date().getTime(),
                                                },
                                            }"
                                            class="
                                                flex
                                                justify-center
                                                items-center
                                                px-4
                                                py-2
                                                shadow-sm
                                                text-sm
                                                font-medium
                                                rounded-md
                                                text-blue-50
                                                bg-blue-600
                                                hover:bg-blue-700
                                                focus:outline-none
                                                focus:ring-2
                                                focus:ring-offset-2
                                                focus:ring-blue-500
                                            "
                                            replace
                                        >
                                            {{ t("profile.edit", "Aanpassen") }}
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="
                                    border-t border-gray-200
                                    bg-gray-50
                                    grid grid-cols-1
                                    divide-y divide-gray-200
                                    sm:grid-cols-3 sm:divide-y-0 sm:divide-x
                                "
                                v-if="organisation.subscription_date"
                            >
                                <div
                                    v-for="stat in stats"
                                    :key="stat.label"
                                    class="
                                        px-6
                                        py-5
                                        text-sm
                                        font-medium
                                        text-center
                                    "
                                >
                                    <span class="text-gray-900"
                                        >{{ stat.label }}:</span
                                    >
                                    {{ " " }}
                                    <span class="text-gray-600">{{
                                        getStat(stat.stat)
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </article>
    </div>
</template>

<script>
export default {
    components: {},
    mounted() {
        this.tenant = document.head.querySelector(
            'meta[name="tenant"]'
        ).content;
        this.getOrganisation();

        Eventing.listen("setLogo", (logo) => this.resetLogo(logo));
    },
    created() {
        this.$router.push({ name: "profile-index" });

        this.user = {
            name: document.head.querySelector('meta[name="company"]')?.content,
            role: this.t("profile.title", "Uw organisatie"),
            imageUrl: document.head.querySelector('meta[name="logo"]')?.content,
        };
    },
    data() {
        return {
            user: {},
            stats: [],
            edit: null,
            isLoading: true,
            tenant: null,
            users: null,
            organisation: {
                subscription_date: null,
            },
        };
    },
    methods: {
        resetLogo(logo) {
            this.user.imageUrl = logo;
            document
                .querySelector('meta[name="logo"]')
                .setAttribute("content", logo);
        },
        getOrganisation() {
            this.isLoading = true;
            axios
                .get("/api/organisation")
                .then((response) => {
                    this.organisation = response.data.data;
                    this.isLoading = false;

                    this.stats = [
                        {
                            label: this.t(
                                "profile.stats.subscription",
                                "Abonnement tot"
                            ),
                            stat: "subscription",
                        },
                        // { label: "Stemgewicht", stat: "voting_weight" },
                        // { label: "Inactief", stat: "inactive" },
                    ];
                })
                .catch((error) => {
                    // alert(error.response.status);
                    this.isLoading = "error";
                });
        },
        getStat(statistic) {
            var self = this;
            var _count = "…";
            try {
                if (this.organisation) {
                    switch (statistic) {
                        case "subscription":
                            return (
                                self.organisation &&
                                self.organisation.subscription_date
                            );
                        default:
                            // _count = 0;
                            break;
                    }
                }
            } catch (error) {}
        },
    },
    computed: {},
};
</script>
